<template>
    <div>
        <div class="show-destop">
            <link rel="stylesheet" href="/themes/web/assets/css/parent.css?v=3">
            <nav-bar-parent/>
            <div id="wrapper" class="wrapper d-flex align-items-stretch">
                <side-bar-parent v-show="$route.name != 'parent_connect_home' && $route.name != 'parent_connect'"></side-bar-parent>

                
                <main id="main" class="ms-sm-auto">

                    <div class="container">
                        <router-view></router-view>
                    </div>

                </main>
                <div class="modal fade" id="updateGradeModal" tabindex="-1" role="dialog" aria-labelledby="updateGradeModal"
                    aria-hidden="true" data-backdrop="static" data-keyboard=false>
                    <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 657px;">
                        <div class="modal-content box-shadow-main" style="padding-top: 65px;">
                            <div class="close-popup" data-dismiss="modal"></div>
                            <div class="img-title">
                                <img src="/themes/ito/images/image01/grade.png" alt="">
                            </div>
                            <h3 class="popup-title">{{$t('choose_grade_1')}}</h3>
                            <h3 class="popup-description mb-20">{{$t('choose_grade_2')}}</h3>

                            <div class="grade-select-body">
                                <div class="grade-select-list">
                                    <div @click="selectGrade(6)"
                                        :class="checkGradeSelected(6)?['grade-select-item', 'active']:['grade-select-item']">6
                                    </div>
                                    <div @click="selectGrade(7)"
                                        :class="checkGradeSelected(7)?['grade-select-item', 'active']:['grade-select-item']">7
                                    </div>
                                    <div @click="selectGrade(8)"
                                        :class="checkGradeSelected(8)?['grade-select-item', 'active']:['grade-select-item']">8
                                    </div>
                                    <div @click="selectGrade(9)"
                                        :class="checkGradeSelected(9)?['grade-select-item', 'active']:['grade-select-item']">9
                                    </div>
                                </div>
                            </div>

                            <div class="text-center">
                                <button class="btn btn-card-header mt-20" style="width: 115px;" @click="confirmSelectGrade">
                                    {{$t('confirm')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="modal fade" id="placementModal" tabindex="-1" role="dialog" aria-labelledby="placementModal"-->
                    <!--aria-hidden="true" data-backdrop="static" data-keyboard=false>-->
                    <!--<div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 657px;">-->
                        <!--<div class="modal-content" style="padding-top: 65px;">-->
                            <!--<div class="close-popup" data-dismiss="modal"></div>-->
                            <!--<div class="img-title">-->
                                <!--<img src="/themes/ito/images/image01/grade.png" alt="">-->
                            <!--</div>-->
                            <!--<h3 class="popup-title-verify">{{$t('choose_grade_3')}}</h3>-->
                            <!--<h3 class="popup-title">{{$t('choose_grade_1')}}</h3>-->
                            <!--<br/>-->

                            <!--<div class="grade-select-body">-->
                                <!--<div class="grade-select-list">-->
                                    <!--<div @click="selectGrade(6)" :class="checkGradeSelected(6)?['grade-select-item', 'active']:['grade-select-item']">6-->
                                    <!--</div>-->
                                    <!--<div @click="selectGrade(7)" :class="checkGradeSelected(7)?['grade-select-item', 'active']:['grade-select-item']">7-->
                                    <!--</div>-->
                                    <!--<div @click="selectGrade(8)" :class="checkGradeSelected(8)?['grade-select-item', 'active']:['grade-select-item']">8-->
                                    <!--</div>-->
                                    <!--<div @click="selectGrade(9)" :class="checkGradeSelected(9)?['grade-select-item', 'active']:['grade-select-item']">9-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->

                            <!--<div class="text-center">-->
                                <!--<button class="ito-btn-large btn-test mt-20" style="width: 150px;" @click="confirmPlacementTest">-->
                                    <!--{{$t('do_placement')}}-->
                                <!--</button>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            </div>
            <footer-element/>
        </div>
        <mobile-download-app/>
    </div>
</template>

<script>
    import FooterElement from "../FooterElement";
    // import NavBarAuth from "../NavBarAuth";
    import NavBarParent from "../NavBarParent";
    import SideBarParent from "../SideBarParent";
    import {getConfigs, getLanguage, soundClick} from "../../utils/utils";
    import {updateLanguage} from '../../models/profile';
    import MobileDownloadApp from '../element/MobileDownloadApp.vue';

    export default {
        name: "ParentLayout",
        data() {
            const grade_default = localStorage.getItem('grade');
            const configs = getConfigs();
            const localizes = configs.localize || [];

            return {
                locate: getLanguage(),
                locate_obj: null,
                user: {
                    grade: 1
                },
                grade_selected: grade_default || 1,
                placement_test: {
                    id: 0,
                    condition_pass: 0,
                    time: 0,
                    total_question: 0,
                },
                configs: configs,
                localizes: localizes,
            };
        },

        components: {
            NavBarParent,
            FooterElement,
            SideBarParent,
            MobileDownloadApp
        },
        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },
        },

        created() {
            this.fetch();
        },

        methods: {
            fetch() {
                const that = this;

                that.$nextTick(function() {
                    var initNanoScroller = function() {
                        if ($('.nano').length > 0) {
                            $(".nano").nanoScroller();
                        }
                    }
                    initNanoScroller();
                })                   
            },
            selectGrade(grade) {
                this.grade_selected = grade;
            },
            confirmSelectGrade() {
                const that = this;

                that.getSoundClick();
                // console.log(this.user_info.placement_test);
                if(this.user_info.student_type != 1 && this.user_info.placement_test == 0){
                    localStorage.setItem('grade', this.grade_selected);
                    $('#updateGradeModal').modal("hide");
                    window.location.reload()
                }else{
                    if (this.user_info.grade >= this.grade_selected) {
                        localStorage.setItem('grade', this.grade_selected);
                        // that.$store.commit("setLoading", this.grade_selected);
                        $('#updateGradeModal').modal("hide");
                        // location.reload();
                        window.location.href = '/'
                    } else {
                        that.$store.commit("setLoading", true);
                        const path = '/placement-test/'+that.grade_selected
                        if (this.$route.path !== path) {
                            this.$router.push(path)
                        }else{
                            that.$store.commit("setLoading", false);
                            $('#updateGradeModal').modal("hide");
                        }
                    }
                }
            },
            checkGradeSelected(grade) {
                return this.grade_selected == grade;
            },
            getSoundClick() {
                soundClick();
            },

            setLocate(e) {
                this.getSoundClick();

                this.locate_obj = e;
                this.locate = e.lang;

                //localStorage.setItem('lang', e);
            },

            updateLocate() {
                const that = this;

                this.getSoundClick();

                localStorage.setItem('lang', this.locate);

                if (that.locate_obj != null) {
                    that.$store.commit("setLoading", true);

                    updateLanguage({
                        id: that.locate_obj.id,
                        is_raw: true
                    }).then((response) => {
                        that.$store.commit("setLoading", false);

                        if (response.data.code != 0) {
                            return;
                        }
                    }).catch(({response}) => {
                        that.$store.commit("setLoading", false);

                        // console.error(response);
                    });
                }

                location.reload();
            },
        }

    }
</script>